import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import HelpDialog from ".";

export default function HelpButton() {
  const theme = useTheme();
  const [showHelpDialog, setShowHelpDialog] = useState(false);
  const toggleHelpDialog = () => {
    setShowHelpDialog(!showHelpDialog);
  };
  const helpBtn = (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        mr: "5%",
        [theme.breakpoints.up("sm")]: {
          display: "none",
        },
      }}
    >
      <Button onClick={toggleHelpDialog}>
        <InfoIcon sx={{ fontSize: ".85rem", mr: "3px" }} />
        {process.env.REACT_APP_COMPLIA_INSTALL === "nj-crc"
          ? "Help/FAQ"
          : "Help"}
      </Button>
    </Box>
  );
  return (
    <>
      {helpBtn}
      {showHelpDialog && (
        <HelpDialog show={showHelpDialog} setShow={toggleHelpDialog} />
      )}
    </>
  );
}
